/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-27 16:26:58
 * @Explain: 邮箱模板 - 类型声明
 */
// 模板链接 对象
export interface TemplateLinkType {
  id?: number;
  /** 语言 */
  lang: string;
  // 链接
  link: string;
  // 文本
  displayText?: string;
  // 标记
  remark?: string;
  // 链接标签
  linkTag?: any;
  // 图片链接
  imgSrc?: string | null;
  imgNum?: number;
  // 所属语言模板
  lang?: string;
  // 自定义唯一键
  uuid?: string;
}

// 模板多语言
export type MuilityLangContentType = {
  lang: string;
  content: string;
  mjmlContent: string;
  thumbnailUrl: string;
  templateLink: TemplateLinkType[];
  // 主题
  subject?: string;
  // 预览文本
  previewText?: string;
  // 主题默认值
  subjectAttributesDefaultValue?: object;
};

// 新增模板 - 声明
export type FormDataType = {
  tag: string;
  templateId?: string | undefined;
  name: string;
  content: string;
  mode?: string;
  lang: string;
  // 营销模板分组id
  groupId?: number;
  // 事务模板分组id
  groupUuid?: string;
  isRichText: number;
  isUnsubscribed: any;
  editorType: any;
  mjmlContent: any;
  // 是否开启多语言
  isMuilityLanguage?: number;
  muilityLangContent?: any[];
  // tab类型
  tabType?: string;
  /** 无默认语言触发开启多语言按钮时，默认语言选框需高亮标识 */
  defaultLangHightLight?: boolean;
  // 更多语言
  moreLang?: any[];
  // 默认值替换逻辑
  attributesDefaultValue?: any;
  // 主题
  subject?: string;
  // 预览文本
  previewText?: string;
  // 主题默认值
  subjectAttributesDefaultValue?: object;
};

export type TransFormDataType = {
  tag?: string;
  template_id?: string | undefined;
  // 分组id
  groupUuid?: string;
  mode: string;
  editorType: any;
  mjmlContent: any;
  /** 发件人 */
  send_name: string;
  /** 地址前缀 */
  address_prefix: string;
  /** 域名 */
  domain: string;
  /** 主题 */
  send_subject: string;
  /** 验证邮箱内容 */
  email: string;
  /** 语言 */
  lang: string;
  /** 邮件内容 */
  content: string;
  /** 预览文本 */
  preview_text: string;

  thumbnail_url?: string;
};

// trans 新增模板 - 声明
export type TransAddDataType = {
  template_id?: string;
  name?: string;
  content?: string;
  lang?: string;
  thumbnailurl?: string;
  editor_type?: string;
  mjml_content?: string;
  send_name?: string;
  send_address?: string;
  send_subject?: string;
  preview_text?: string;
  fontConfig?: any;
  // tab类型
  tabType?: string;
};

// 模板列表 - 声明
export type TemplateListType = {
  timeoutId?: number;
  // 超时模板名称
  timeoutName?: string;
};

// 模板列表 - 声明
export type TemplateTransListType = {
  timeoutId?: number;
  // 超时模板名称
  timeoutName?: string;
  // tab类型
  tabType?: string;
};
// 模板自动保存配置 - 声明
export type TemplateAutoSaveConfigType = {
  // 更新id来源新增
  editIdByAdd?: number;
};

// 新建模板方式
export enum TemplateModeEnum {
  /** mjml富文本编辑器 */
  mjml = 'mjml',
  /** 富文本编辑器 */
  richText = 'richText',
  /** 上传HTML文件 */
  upload = 'upload',
  /** 设计模板布局 */
  paste = 'paste',
  /** 上传Mjml文件 */
  uploadMjml = 'uploadMjml',
}

// 新建模板方式
export enum EditorModeEnum {
  /** 富文本编辑器  新版本 */
  richText = 'rich-text',
  /** mjml编辑器 新版本 */
  mjml = 'mjml',
  /** html编辑器  */
  html = 'html',
  // 兼容历史 UPLOAD HTML
  upload = 'upload',
  // AI生成模板
  ai = 'ai',
}

// 邮件创建类型 - 后端用于区分模板来源
export enum EmailCreateTypeEnum {
  html = 1, // HTML
  dragDrop = 2, // 拖拉拽模板
  ai = 3, // AI生成模板
}

// 编辑器 Tab 类型 - 与 EmailCreateTypeEnum 对应
export const EDITOR_TAB_TYPE = {
  DRAG: 2,
  AI: 3,
} as const;

// 根据编辑器模式 editorType 推导出 emailCreateType
export const getEmailCreateType = (
  editorType?: EditorModeEnum | string,
): EmailCreateTypeEnum => {
  switch (editorType) {
    case EditorModeEnum.mjml:
      return EmailCreateTypeEnum.dragDrop; // 拖拉拽
    case EditorModeEnum.ai:
      return EmailCreateTypeEnum.ai; // AI生成
    default:
      return EmailCreateTypeEnum.html; // HTML
  }
};

// 列表 Email Create Type 列展示文案 - 以初次创建时的类型为准
// 枚举值固定为英文：AI / HTML / Drag & Drop
export const getEmailCreateTypeLabel = (
  emailCreateType?: EmailCreateTypeEnum | 0 | number,
): string => {
  switch (emailCreateType) {
    case EmailCreateTypeEnum.ai:
      return 'AI';
    case EmailCreateTypeEnum.dragDrop:
      return 'Drag & Drop';
    case EmailCreateTypeEnum.html:
      return 'HTML';
    default:
      return '-';
  }
};

// 链接上的参数 - source
export enum JumpSource {
  default = 'default',
  // 首页代办
  todoList = 'todoList',
  // 活动列表
  activityList = 'activityList',
  // 周期活动列表
  cycleActivityList = 'cycleActivityList',
  // ab测试活动列表
  abTestActivityList = 'abTestActivityList',
  // whatsapp活动列表
  whatsAppActivityList = 'whatsAppActivityList',
  // 活动审批列表
  approvalList = 'approvalList',
  // 活动审批详情
  approvalDetails = 'approvalDetails',
  // 活动报表
  activityReport = 'activityReport',
  // 标签管理列表
  tagList = 'tagList',
}

/**
 * Select 及 新增修改组件
 * list右侧渲染内容
 */

export type SelectAndUpdateRightTypes = 'content' | 'action';
export enum SelectAndUpdateRight {
  /** 内容 */
  CONTENT = 'content',
  /** 操作 */
  ACTION = 'action',
}

// 文件夹 - 下拉选项固定字段
export enum DefaultSelectKey {
  /** 所有 */
  ALL = 1,
  /** 未分组 */
  UNGROUPED = 2,
}

// 操作类型枚举
export enum OperationEnum {
  /** 新增 */
  ADD = 'add',
  /** 编辑 */
  EDIT = 'edit',
  /** 删除 */
  DEL = 'delete',
  /** 提交 */
  SUBMIT = 'SUBMIT',
  /** 拖拽 */
  DRAG = 'DRAG',
}

// Select 及 新增修改 - 下拉项类型
export type optsTypes = {
  /** 选项值 */
  value: string;
  /** 选项显示的内容 */
  text: string | React.ReactNode;
  /** 下拉项右侧渲染内容类型 */
  rightType?: SelectAndUpdateRight;
  /** 自定义右侧内容 */
  content?: string | React.ReactNode;
  /** 标识list不转换至编辑状态 */
  unChangeEditStatus?: any;
  /** 其余字段 */
  [key: string]: any;
};

// 列表tab类型选项
export enum ListTabType {
  market = 'market',
  transaction = 'transaction',
}
// 内置body 属性 写入类型 语言 取消订阅
export enum HtmlBodySystemAttribute {
  // 语言
  systemLang = 'systemlang',
  // 取消订阅
  systemIsUnsubscribed = 'systemisunsubscribed',
  // 编辑器类型
  systemEditorType = 'systemeditortype',
}
